import {Fragment} from "react";
import {IconButton} from "@mui/material";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import SaveDialog from "./SaveDialog";
import {useBoolState} from "@/hooks";
import {SaveThirdPartyDeviceMutationVariables} from "../../queries.generated";
import {ThirdPartyDevice} from "../../types";
import {defineMessage} from "react-intl";

type Props = {
    device: ThirdPartyDevice;
    onSuccess: () => void;
};

export default ({onSuccess, device}: Props) => {
    const [isOpen, open, close] = useBoolState();
    const initialData: SaveThirdPartyDeviceMutationVariables = {
        id: device.id,
        description: device.description ?? "",
        sipUser: device.sipUser,
        sipPassword: device.sipPassword,
    };

    return (
        <Fragment>
            <IconButton color="primary" size="small" onClick={open}>
                <FontAwesomeIcon icon="pencil-alt" />
            </IconButton>
            <SaveDialog
                isOpen={isOpen}
                close={close}
                title={defineMessage({
                    id: "devices.third_party.update",
                    defaultMessage: "Update third-party device: {name}",
                })}
                titleVariables={{name: device.description}}
                initialData={initialData}
                onSuccess={onSuccess}
                cacheKeyPostfix={`update_${device.id}`}
            />
        </Fragment>
    );
};
